<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      ref="table"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="packages"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
        <div class="flex flex-wrap-reverse items-center">
          <div
            class="flex items-center justify-between p-3 mb-4 mr-4 text-base text-lg font-medium border border-solid rounded-lg cursor-pointer text-primary border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Create New Package</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer">
          <div
            class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ packages.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : packages.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Package Title</vs-th>
        <vs-th sort-key="simulationCount">Simulation Count</vs-th>
        <vs-th sort-key="mitreSize">Mitre Attack Count</vs-th>
        <vs-th sort-key="validFor">Simulations Valid For</vs-th>
        <vs-th sort-key="technicalSupport">Technical Support</vs-th>
        <vs-th sort-key="blueTeam">Blue Team</vs-th>
        <vs-th sort-key="mitreSize">Monthly Cost</vs-th>
        <vs-th sort-key="yearlyCost">Yearly Cost</vs-th>
        <vs-th sort-key="createdAt">Created At</vs-th>
        <vs-th sort-key="updatedAt">Updated At</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="centered-cell">
              <p class="font-medium truncate">{{ tr.title }}</p>
            </vs-td>

            <vs-td class="centered-cell">
              <p>{{tr.simulationCount === -1 ? 'unlimited' : tr.simulationCount}}</p>
            </vs-td>
            <vs-td class="centered-cell">
              <p>{{tr.mitreSize === -1 ? 'unlimited' : tr.mitreSize}}</p>
            </vs-td>
            <vs-td class="centered-cell">
              <p v-if="tr.validFor === -1">license time</p>
              <p v-else>{{tr.validFor > 1 ? `${tr.validFor} days` : `${tr.validFor} day`}}</p>
            </vs-td>
            <vs-td class="centered-cell">
              <i
                :class="tr.technicalSupport === true ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"
                class="text-xl text-center"
              ></i>
            </vs-td>
            <vs-td class="centered-cell">
              <i
                :class="tr.blueTeam === true ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"
                class="text-xl text-center"
              ></i>
            </vs-td>
            <vs-td class="centered-cell">
              <p>${{tr.monthlyCost}}</p>
            </vs-td>
            <vs-td class="centered-cell">
              <p>${{tr.yearlyCost}}</p>
            </vs-td>
            <vs-td class="centered-cell">
              <p>{{ tr.createdAt | moment('DD/MM/YYYY HH:mm')}}</p>
            </vs-td>

            <vs-td class="centered-cell">
              <p>{{ tr.updatedAt | moment('DD/MM/YYYY HH:mm')}}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr._id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './PackagesSidebar.vue'
import eventBus from '../../eventBus'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      selected: [],
      packages: [],
      itemsPerPage: 4,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.packages.length
    }
  },
  methods: {
    refreshTable () {
      this.$http.get('/management/packages').then((res) => {
        this.packages = res.data.packages
      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$swal({
        title: 'Do you really want to delete the package?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/management/packages/${id}`)
            .then((res) => {
              this.refreshTable()
              if (res.data.status === true) {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'success',
                  toast: true,
                  title: 'Package successfully deleted.',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true
                })
              } else {
                this.$swal({
                  position: 'bottom-start',
                  icon: 'error',
                  toast: true,
                  title: 'Error occurred deleting the package.',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true
                })
              }
            })
            .catch((err) => {
              this.refreshTable()
              this.$swal({
                position: 'bottom-start',
                icon: 'error',
                toast: true,
                title: 'Error occurred deleting the package.',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
              })
            })
        }
      })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      console.log(data)
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    }
  },
  created () {
    this.refreshTable()
    eventBus.$on('refresh-packages', () => {
      this.refreshTable()
    })
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr:hover {
        transform: translate(0) !important;
        background: rgba(var(--vs-primary), 0.05) !important;
      }
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.centered-cell {
  display: table-cell;
  vertical-align: middle;
}
</style>